import styled from 'styled-components'

const NameContainer = styled.div`
  height: 100%;
  display: flex;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    cursor: pointer;
  }
`

const TotalContainer = styled.div`
  height: 100%;
  width: 70px;
  margin-right: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 70px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    cursor: pointer;
  }
`

export { NameContainer, TotalContainer }



// WEBPACK FOOTER //
// ./src/components/productionstatus/_Styled.js